import { useEffect, useState } from "react";

/**
 * Counts down from durationSeconds to 0. Restarts when resetKey (or the
 * duration) changes.
 */
export const useCountdown = (durationSeconds: number, resetKey?: unknown) => {
  const [secondsLeft, setSecondsLeft] = useState(durationSeconds);

  useEffect(() => {
    setSecondsLeft(durationSeconds);
    const id = window.setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          window.clearInterval(id);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => window.clearInterval(id);
  }, [resetKey, durationSeconds]);

  return {
    secondsLeft,
    expired: secondsLeft <= 0,
    progress: Math.max(0, (secondsLeft / durationSeconds) * 100),
  };
};
